import { createAsyncThunk } from '@reduxjs/toolkit';

import { del } from 'api/requests';

export const deleteGaranteeLetter = createAsyncThunk(
  'EN_guaranteeLetter/deleteGaranteeLetter',
  async (id: number, thinkApi) => {
    try {
      const req = await del(`/api/standards/engineering_networks/${id}/guarantee-letter/delete/`);
      return req;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
